import { useUserContext } from './useUserContext';
import { useAuthContext } from './useAuthContext';
import { useNavigate } from 'react-router-dom';
import { adminNavItems } from './../components/layout/dashboards/admin/admin-config';
import { companyNavItems } from './../components/layout/dashboards/company/company-config';
import { agentNavItems } from './../components/layout/dashboards/agent/agent-config';
import { businessNavItems } from '../components/layout/dashboards/business/business-config';
import { BVTConstants } from '../utils/BVTConstants';
import { paths } from '../utils/paths';
import toast from 'react-hot-toast';

export const useNavItems = () => {
    const user = useUserContext();
    const {dispatch} = useAuthContext();
    const navigate = useNavigate();

    const getNavItems = () => {
        if(user === null || user.role === null){
            return null;
        }
        switch (user.role) {
            case BVTConstants.USER_TYPE_ADMIN:
                return adminNavItems;
            case BVTConstants.USER_TYPE_BUSINESS:
                return businessNavItems;
            case BVTConstants.USER_TYPE_AGENT:
                return agentNavItems;
            case BVTConstants.USER_TYPE_COMPANY:
                return companyNavItems;
            default:
                return null;
        }
    }

    const getPopOverPaths = () => {
        if(user === null || user.role === null){
            return {settings: null, account: null};
        }else {
            switch (user.role) {
                case BVTConstants.USER_TYPE_ADMIN:
                    return {settings: paths.admin.settings, account: paths.admin.profile};
                case BVTConstants.USER_TYPE_BUSINESS:
                    return {settings: paths.business.settings, account: paths.business.profile};
                case BVTConstants.USER_TYPE_AGENT:
                    return {settings: paths.agent.settings, account: paths.agent.profile};
                case BVTConstants.USER_TYPE_COMPANY:
                        return {settings: paths.agent.settings, account: paths.agent.profile};
                default:
                    return null;
            }
        }
    }

    const getNavLabel = (path:string) => {
        switch (path) {
            case paths.admin.home:
                return "Overview";
            case paths.admin.users:
            case paths.admin.newUser:
            case paths.admin.viewUser:
            case paths.admin.editBusinessBase:
            case paths.admin.agentBusinesses:
                return "Businesses";
            case paths.admin.companies:
            case paths.admin.newCompany:
            case paths.admin.editCompanyBase:
            case paths.admin.viewCompany:
                return "Companies";
            case paths.admin.agents:
            case paths.admin.newAgent:
            case paths.admin.viewAgent:
                return "Agents";
            case paths.admin.assessment:
            case paths.admin.newAssessment:
            case paths.admin.updateAssessment:
            case paths.admin.assessmentDetails:
                return "Assessments";
            case paths.admin.program:
            case paths.admin.programForm:
            case paths.admin.programDetails:
                return "Programs";
            case paths.admin.workflows:
            case paths.admin.workflowView:
            case paths.admin.assignWorkflow:
                return "Workflows & Tasks";
            case paths.admin.activities:
                return "Activities";
            case paths.admin.subscriptions:
                return "Subscriptions";
            case paths.admin.payments:
                return "Payments";
            case paths.admin.profile:
                return "Profile";
            case paths.admin.settings:
                return "Settings";

            case paths.agent.home:
                return "Overview";
            case paths.agent.clients:
            case paths.agent.clientDetail:
                return "Clients";
            case paths.agent.workflows:
            case paths.agent.workflowView:
            case paths.agent.assignWorkflow:
                return "Workflows & Tasks";
            case paths.agent.assessmentView:
            case paths.agent.assessmentForm:
            case paths.agent.assessmentDetails:
                return "Assessment";
            case paths.agent.activities:
                return "Activities";
            case paths.agent.settings:
                return "Settings";
            case paths.agent.profile:
            case paths.agent.companyProfile:
            case paths.agent.companyEditServiceInfo:
                return "Profile";
            case paths.agent.companyAgents:
            case paths.agent.companyAgentView:
                return "Agents";
            case paths.agent.companyPlatformSubscription:
                return "Subscriptions";
            case paths.agent.companySubscriptionDetails:
                return "Subscription Details";
            case paths.agent.payments:
                return "Payments";
            case paths.agent.support:
                return "Support";
                
            case paths.business.home:
                return "Overview";
            case paths.business.support:
                return "Support";
            case paths.business.subscriptions:
                return "Subscriptions";
            case paths.business.payments:
                return "Payments";
            case paths.business.workflows:
            case paths.business.workflowView:
            case paths.business.subscribeWorkflow:
                return "Workflows & Tasks";
            case paths.business.assessmentView:
            case paths.business.assessmentForm:
            case paths.business.assessmentDetails:
                return "Assessment";

            case paths.common.workflowView:
                return "Workflows & Tasks";
            default:
                return "";
        }
    }

    return {getNavItems, getPopOverPaths, getNavLabel}
}